import { getUniversalEnv } from 'app/lib/get-universal-env';

export const getBackendServerUrl = () => {
  const backendServerProtocol = getUniversalEnv('BACKEND_SERVER_PROTOCOL');

  if (typeof window == 'undefined') {
    return `${backendServerProtocol}://${getUniversalEnv('BACKEND_HOST_FOR_SERVER')}`;
  }

  return `${backendServerProtocol}://${getUniversalEnv('BACKEND_HOST_FOR_CLIENT')}`;
};
